export default {
    config: (state) => (configName) => state.config[configName],
    user: (state) => state.user,
    userId: (state, getters) => getters.user.id,
    username: (state, getters) => getters.user.username,
    nickname: (state, getters) => getters.user.nickname,
    email: (state, getters) => getters.user.email,
    isVerifiedEmail: (state, getters) => getters.user.email_verified_at !== undefined ? getters.user.email_verified_at : true,
    isLogged: (state, getters) => (getters.userId > 0),
    pricesEUR: (state) => state.config.payments.pricesEUR,
    recommendedPrices: (state) => state.config.payments.recommended,
    paymentCurrency: (state) => state.config.payments.currency,
    getMenuVisibility: (state) => state.componentVisibility.menu,
    getComponentVisibility: (state) => state.componentVisibility,
    paymentPrices: (state) => state.config.payments.cost,
    goldRate: (state) => state.config.payments.goldRate,
    pointsMultipliedBy: (state) => state.config.payments.multiplePointsBy,
    silverRate: (state) => state.config.payments.silverRate,
    getStripeSku: (state) => state.config.stripe.sku || [],
    getStripePk: (state) => state.config.stripe.PK,
    getReferredFromUser: (state) => state.config.referred.from || '',
    minAmountPayPalUsage: (state) => state.config.payments.minimumToUsePayPal,
    hasPayPalRestriction: (state) => state.userRestrictions.has_disabled_paypal > 0,
    hasStripelRestriction: (state) => state.userRestrictions.has_disabled_stripe > 0,
    hasReachedPayPalQualifiedAmount: (state) => state.userRestrictions.has_reached_paypal_qualified_amount,
    isAdmin: (state) => state.userRole.isAdmin,
    isDeveloper: (state) => state.userRole.isDeveloper,
    isModerator: (state) => state.userRole.isModerator,
    onlineInGame: (state) => state.inGame.totalOnline,
    offlineInGame: (state) => state.inGame.totalOffline,
    zushinPoints: (state, getters) => getters.user.zushinPoints,
    referralLink: (state, getters) => getters.user.referralLink,
    totalReferred: (state, getters) => getters.user.totalReferred,
    totalReferredCompleted: (state, getters) => getters.user.totalReferredCompleted,
    notifications: (state) => state.notifications,
    isPayPalEnabled: (state) =>  state.config.paypal.isEnabled,
    getPayPalConfig: (state) =>  state.config.paypal,
    isStripeEnabled: (state) =>  state.config.stripe.isEnabled,
    lastNotificationId: (state) => state.lastNotificationId,
};
